import styled from 'styled-components';
import { styledHeader, Typography } from './BaseTypes';
import { styledMargin } from '../layout/Margin';

export const H3 = styled.h3<Typography>`
  ${styledHeader}
  ${styledMargin}
  font-size: 32px;
`;
